var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c(
            "div",
            {
              staticClass: "back",
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _c("img", {
                attrs: { src: require("images/back.png"), width: "10" },
              }),
              _c("span", [_vm._v("返回")]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "export-btn",
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.exportData },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "el-select",
            {
              staticClass: "grade-select-list",
              attrs: { size: "small", "value-key": "gradeNum" },
              model: {
                value: _vm.startYearData,
                callback: function ($$v) {
                  _vm.startYearData = $$v
                },
                expression: "startYearData",
              },
            },
            _vm._l(_vm.studentGradeList, function (item, i) {
              return _c("el-option", {
                key: "grade-" + i,
                attrs: { label: item.gradeName, value: item },
              })
            }),
            1
          ),
          _c("div", { staticClass: "info-top" }, [
            _c("div", { staticClass: "avatar" }, [
              _vm._v(
                _vm._s(
                  _vm.studentDetail.studName
                    ? _vm.studentDetail.studName.split("")[0]
                    : ""
                )
              ),
            ]),
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.studentDetail.studName)),
            ]),
          ]),
          _c("div", { staticClass: "info-bottom" }, [
            _c("span", [
              _vm._v("学校：" + _vm._s(_vm.studentDetail.schoolName)),
            ]),
            _c("span", [
              _vm._v("年级：" + _vm._s(_vm.startYearData.gradeName)),
            ]),
            _c("span", [
              _vm._v("班级：" + _vm._s(_vm.startYearData.className)),
            ]),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "section section1" }, [
        _c("div", { staticClass: "title" }, [_vm._v("学年总结")]),
        _c(
          "div",
          { staticClass: "container", staticStyle: { margin: "0 -5px" } },
          [
            _c(
              "div",
              { staticClass: "total-item", staticStyle: { flex: "4" } },
              [
                _vm._m(0),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(_vm.studentOverviewData.examNum)),
                  ]),
                  _c("div", { staticClass: "desc" }, [
                    _vm._v("共参加考试（场）"),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "total-item", staticStyle: { flex: "4" } },
              [
                _vm._m(1),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(
                      _vm._s(_vm.studentOverviewData.schoolExamNum) +
                        "/" +
                        _vm._s(_vm.studentOverviewData.regionExamNum) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "desc" }, [
                    _vm._v("学校/区域考试（场）"),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "total-item", staticStyle: { flex: "3" } },
              [
                _vm._m(2),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(_vm.studentOverviewData.wonderNum)),
                  ]),
                  _c("div", { staticClass: "desc" }, [_vm._v("优秀（场）")]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "total-item", staticStyle: { flex: "3" } },
              [
                _vm._m(3),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(_vm.studentOverviewData.goodNum)),
                  ]),
                  _c("div", { staticClass: "desc" }, [_vm._v("良好（场）")]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "total-item", staticStyle: { flex: "3" } },
              [
                _vm._m(4),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(_vm.studentOverviewData.passNum)),
                  ]),
                  _c("div", { staticClass: "desc" }, [_vm._v("及格（场）")]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "total-item", staticStyle: { flex: "3" } },
              [
                _vm._m(5),
                _c("div", { staticClass: "right" }, [
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v(_vm._s(_vm.studentOverviewData.tiredNum)),
                  ]),
                  _c("div", { staticClass: "desc" }, [_vm._v("学困（场）")]),
                ]),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "left", staticStyle: { position: "relative" } },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.ifRadarChartShow,
                    expression: "ifRadarChartShow",
                  },
                ],
                attrs: { id: "radar" },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.ifRadarChartShow,
                      expression: "!ifRadarChartShow",
                    },
                  ],
                  staticStyle: {
                    "text-align": "center",
                    height: "150px",
                    "padding-top": "150px",
                    color: "#999",
                    "background-color": "#fff",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("images/nodata.png"),
                      alt: "",
                      width: "100",
                    },
                  }),
                  _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                    _vm._v("暂无数据"),
                  ]),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "top" }, [
              _vm.bestAndWorstExamData && _vm.bestAndWorstExamData.bestExam
                ? _c("div", [
                    _c("div", { staticClass: "label" }, [_vm._v("最好成绩")]),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.bestAndWorstExamData.bestExam.examName)
                      ),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: { color: "#5192F9" },
                              },
                              [
                                _c("span", [_vm._v("班级平均分")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.bestExam
                                          .classAverageScore
                                      ).toFixed(2)
                                    ) + "分"
                                  ),
                                ]),
                              ]
                            ),
                            parseFloat(
                              _vm.bestAndWorstExamData.bestExam.totalScore
                            ) > 0
                              ? _c("el-progress", {
                                  attrs: {
                                    format: _vm.format,
                                    color: "#5192F9",
                                    "stroke-width": 10,
                                    "show-text": false,
                                    percentage: parseFloat(
                                      (_vm.bestAndWorstExamData.bestExam
                                        .classAverageScore /
                                        _vm.bestAndWorstExamData.bestExam
                                          .totalScore) *
                                        100
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: { color: "#48BFFE" },
                              },
                              [
                                _c("span", [_vm._v("击败本班级同学")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.bestExam
                                          .classBitRatio * 100
                                      ).toFixed(2)
                                    ) + "%"
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-progress", {
                              attrs: {
                                format: _vm.format,
                                "stroke-width": 10,
                                "show-text": false,
                                color: "#48BFFE",
                                percentage: parseFloat(
                                  _vm.bestAndWorstExamData.bestExam
                                    .classBitRatio * 100
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._m(6),
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: { color: "rgba(255, 190, 65, 1)" },
                              },
                              [
                                _c("span", [_vm._v("年级平均分")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.bestExam
                                          .gradeAverageScore
                                      ).toFixed(2)
                                    ) + "分"
                                  ),
                                ]),
                              ]
                            ),
                            parseFloat(
                              _vm.bestAndWorstExamData.bestExam.totalScore
                            ) > 0
                              ? _c("el-progress", {
                                  attrs: {
                                    format: _vm.format,
                                    "stroke-width": 10,
                                    "show-text": false,
                                    color: "rgba(255, 213, 132, 1)",
                                    percentage: parseFloat(
                                      (_vm.bestAndWorstExamData.bestExam
                                        .gradeAverageScore /
                                        _vm.bestAndWorstExamData.bestExam
                                          .totalScore) *
                                        100
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: {
                                  color: "rgba(254, 174, 104, 1)",
                                },
                              },
                              [
                                _c("span", [_vm._v("击败本年级同学")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.bestExam
                                          .gradeBitRatio * 100
                                      ).toFixed(2)
                                    ) + "%"
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-progress", {
                              attrs: {
                                format: _vm.format,
                                "stroke-width": 10,
                                "show-text": false,
                                color: "rgba(254, 174, 104, 1)",
                                percentage: parseFloat(
                                  _vm.bestAndWorstExamData.bestExam
                                    .gradeBitRatio * 100
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        height: "150px",
                        "padding-top": "70px",
                        color: "#999",
                        "background-color": "#fff",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("images/nodata.png"),
                          alt: "",
                          width: "100",
                        },
                      }),
                      _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                        _vm._v("暂无数据"),
                      ]),
                    ]
                  ),
            ]),
            _c("div", { staticClass: "bottom" }, [
              _vm.bestAndWorstExamData && _vm.bestAndWorstExamData.worstExam
                ? _c("div", [
                    _c("div", { staticClass: "label" }, [_vm._v("最差成绩")]),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(_vm.bestAndWorstExamData.worstExam.examName)
                      ),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: { color: "#5192F9" },
                              },
                              [
                                _c("span", [_vm._v("班级平均分")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.worstExam
                                          .classAverageScore
                                      ).toFixed(2)
                                    ) + "分"
                                  ),
                                ]),
                              ]
                            ),
                            parseFloat(
                              _vm.bestAndWorstExamData.worstExam.totalScore
                            ) > 0
                              ? _c("el-progress", {
                                  attrs: {
                                    format: _vm.format,
                                    "stroke-width": 10,
                                    "show-text": false,
                                    color: "#5192F9",
                                    percentage: parseFloat(
                                      (_vm.bestAndWorstExamData.worstExam
                                        .classAverageScore /
                                        _vm.bestAndWorstExamData.worstExam
                                          .totalScore) *
                                        100
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: { color: "#48BFFE" },
                              },
                              [
                                _c("span", [_vm._v("击败本班级同学")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.worstExam
                                          .classBitRatio * 100
                                      ).toFixed(2)
                                    ) + "%"
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-progress", {
                              attrs: {
                                format: _vm.format,
                                "stroke-width": 10,
                                "show-text": false,
                                color: "#48BFFE",
                                percentage:
                                  _vm.bestAndWorstExamData.worstExam
                                    .classBitRatio * 100,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._m(7),
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: {
                                  color: "rgba(255, 213, 132, 1)",
                                },
                              },
                              [
                                _c("span", [_vm._v("年级平均分")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.worstExam
                                          .gradeAverageScore
                                      ).toFixed(2)
                                    ) + "分"
                                  ),
                                ]),
                              ]
                            ),
                            parseFloat(
                              _vm.bestAndWorstExamData.worstExam.totalScore
                            ) > 0
                              ? _c("el-progress", {
                                  attrs: {
                                    format: _vm.format,
                                    "stroke-width": 10,
                                    "show-text": false,
                                    color: "rgba(255, 213, 132, 1)",
                                    percentage: parseFloat(
                                      (_vm.bestAndWorstExamData.worstExam
                                        .gradeAverageScore /
                                        _vm.bestAndWorstExamData.worstExam
                                          .totalScore) *
                                        100
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                staticStyle: {
                                  color: "rgba(254, 174, 104, 1)",
                                },
                              },
                              [
                                _c("span", [_vm._v("击败本年级同学")]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.bestAndWorstExamData.worstExam
                                          .gradeBitRatio * 100
                                      ).toFixed(2)
                                    ) + "%"
                                  ),
                                ]),
                              ]
                            ),
                            _c("el-progress", {
                              attrs: {
                                format: _vm.format,
                                "stroke-width": 10,
                                "show-text": false,
                                color: "rgba(254, 174, 104, 1)",
                                percentage:
                                  _vm.bestAndWorstExamData.worstExam
                                    .gradeBitRatio * 100,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ])
                : _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        height: "150px",
                        "padding-top": "70px",
                        color: "#999",
                        "background-color": "#fff",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("images/nodata.png"),
                          alt: "",
                          width: "100",
                        },
                      }),
                      _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                        _vm._v("暂无数据"),
                      ]),
                    ]
                  ),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "section section2" },
        [
          _c(
            "el-select",
            {
              staticStyle: {
                position: "absolute",
                top: "18px",
                right: "70px",
                width: "100px",
              },
              attrs: { size: "small" },
              on: {
                change: function ($event) {
                  return _vm.examOverview()
                },
              },
              model: {
                value: _vm.examOverviewSubjectCode,
                callback: function ($$v) {
                  _vm.examOverviewSubjectCode = $$v
                },
                expression: "examOverviewSubjectCode",
              },
            },
            _vm._l(_vm.subjectList, function (s, i) {
              return _c("el-option", {
                key: i,
                attrs: { label: s.dicName, value: s.dicCode },
              })
            }),
            1
          ),
          _c("div", { staticClass: "title" }, [_vm._v("考试概述")]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.examOverviewLoading,
                  expression: "examOverviewLoading",
                },
              ],
              attrs: {
                "row-class-name": "section2_row_class",
                "header-cell-class-name": "section2_table_header_th",
                data: _vm.examOverviewData,
              },
              on: {
                "cell-mouse-enter": _vm.onCellMouseEnter,
                "cell-mouse-leave": _vm.onCellMouseLeave,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "考试名称", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.examName))]),
                        scope.row.isMore == 2
                          ? _c("span", [
                              scope.row.isHover
                                ? _c("img", {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      src: require("images/region_exam_mark_w.png"),
                                      alt: "",
                                    },
                                  })
                                : _c("img", {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      src: require("images/region_exam_mark.png"),
                                      alt: "",
                                    },
                                  }),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "courseName", label: "学科", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.examType))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "score", label: "分数", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { label: "班级均分", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            parseFloat(scope.row.classAverageScore).toFixed(2)
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "年级均分", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            parseFloat(scope.row.gradeAverageScore).toFixed(2)
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "classRanking",
                  label: "班级排名",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "gradeRanking",
                  label: "年级排名",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetailReport(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看详细报告")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "section section3" }, [
        _c("div", { staticClass: "title" }, [_vm._v("学科竞争力")]),
        _c(
          "div",
          { staticClass: "exam-ranking-subject" },
          [
            _c(
              "el-select",
              {
                staticStyle: { width: "100px" },
                attrs: { size: "small" },
                on: {
                  change: function ($event) {
                    return _vm.examRanking()
                  },
                },
                model: {
                  value: _vm.examRankingSubjectCode,
                  callback: function ($$v) {
                    _vm.examRankingSubjectCode = $$v
                  },
                  expression: "examRankingSubjectCode",
                },
              },
              _vm._l(_vm.subjectList, function (s, i) {
                return _c("el-option", {
                  key: i,
                  attrs: { label: s.dicName, value: s.dicCode },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "switch" }, [
          _c(
            "div",
            {
              staticClass: "switch-item",
              class: { active: _vm.examRankingType == 1 },
              on: {
                click: function ($event) {
                  _vm.examRankingType = 1
                },
              },
            },
            [_vm._v("对比班级")]
          ),
          _c(
            "div",
            {
              staticClass: "switch-item",
              class: { active: _vm.examRankingType == 2 },
              on: {
                click: function ($event) {
                  _vm.examRankingType = 2
                },
              },
            },
            [_vm._v("对比年级")]
          ),
        ]),
        _c("div", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.examRankingLoading,
              expression: "examRankingLoading",
            },
            {
              name: "show",
              rawName: "v-show",
              value: _vm.examRankingData.length > 0,
              expression: "examRankingData.length > 0",
            },
          ],
          attrs: { id: "line-chart" },
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.examRankingLoading,
                expression: "examRankingLoading",
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.examRankingData.length == 0,
                expression: "examRankingData.length == 0",
              },
            ],
            staticClass: "not-data",
          },
          [
            _c("img", {
              attrs: {
                src: require("images/nodata.png"),
                alt: "",
                width: "100",
              },
            }),
            _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
              _vm._v("暂无数据"),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "section section4" }, [
        _c("div", { staticClass: "title" }, [_vm._v("薄弱知识点情况")]),
        _c(
          "div",
          { staticClass: "legend" },
          [
            _vm.currentPointOverviewSubject.examBases
              ? [
                  _c("span", { staticStyle: { "font-size": "14px" } }, [
                    _vm._v("知识点考试："),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { size: "small", clearable: "" },
                      on: { change: _vm.pointOverviewDetail },
                      model: {
                        value: _vm.selectExamId,
                        callback: function ($$v) {
                          _vm.selectExamId = $$v
                        },
                        expression: "selectExamId",
                      },
                    },
                    _vm._l(
                      _vm.currentPointOverviewSubject.examBases,
                      function (s, i) {
                        return _c("el-option", {
                          key: i,
                          attrs: {
                            title: s.examName,
                            label: s.examName,
                            value: s.id,
                          },
                        })
                      }
                    ),
                    1
                  ),
                  _c("i", {
                    staticClass: "el-icon-question",
                    staticStyle: {
                      "margin-right": "10px",
                      "font-size": "18px",
                    },
                    attrs: { title: "根据所选知识点筛选考试" },
                  }),
                ]
              : _vm._e(),
            _c("div", { staticClass: "item" }, [
              _c("span", {
                staticClass: "circle",
                style: {
                  backgroundColor: _vm.colorList[_vm.currentPointSubjectIndex],
                },
              }),
              _c("span", [_vm._v("薄弱知识点")]),
            ]),
            _c("div", { staticClass: "item" }, [
              _c("span", {
                staticClass: "circle",
                style: {
                  backgroundColor:
                    _vm.colorListOpacity[_vm.currentPointSubjectIndex],
                },
              }),
              _c("span", [_vm._v("已掌握知识点")]),
            ]),
          ],
          2
        ),
        _c(
          "div",
          { ref: "scroll_container", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "div",
              { ref: "container", staticClass: "container scroll_container" },
              _vm._l(_vm.pointOverviewData, function (subject, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(subject, i)
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "pie-chart",
                      attrs: { id: "pie-chart" + i },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "subject-name",
                        style: { color: _vm.colorList[i] },
                      },
                      [_vm._v(_vm._s(subject.subjectName))]
                    ),
                    i == _vm.currentPointSubjectIndex
                      ? _c("div", {
                          staticClass: "tringle",
                          style: {
                            backgroundColor:
                              _vm.colorList[_vm.currentPointSubjectIndex],
                          },
                        })
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _c(
          "div",
          { staticClass: "container" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  "row-class-name": "section4_row_class",
                  "header-cell-style": {
                    "background-color":
                      _vm.colorList[_vm.currentPointSubjectIndex],
                    color: "#fff",
                  },
                  data: _vm.currentPointOverviewData,
                  "max-height": "400",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "objectName",
                    width: "240",
                    label: "知识点",
                    align: "left",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "examNum",
                    label: "考试次数",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "examWeakNum",
                    label: "薄弱次数",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "100px",
                    label: "平均掌握度",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-rate", {
                            attrs: {
                              disabled: "",
                              max: 5,
                              "text-color": "#ff9900",
                              "score-template": "{value}",
                            },
                            model: {
                              value: scope.row.starScore,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "starScore", $$v)
                              },
                              expression: "scope.row.starScore",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "个人平均得分率", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                parseFloat(scope.row.studentRate * 100).toFixed(
                                  2
                                )
                              ) + "%"
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "班级平均得分率", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                parseFloat(scope.row.classRate * 100).toFixed(2)
                              ) + "%"
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "年级平均得分率", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                parseFloat(scope.row.gradeRate * 100).toFixed(2)
                              ) + "%"
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "操作", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticStyle: { color: "#666" },
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.seeQuestion(scope.row)
                                },
                              },
                            },
                            [_vm._v("查看题目")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.exportDialogVisible,
            size: "tiny",
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "text-align": "right",
                    color: "#333",
                    fontSize: "15px",
                    "line-height": "30px",
                  },
                  attrs: { span: 12 },
                },
                [
                  _vm.exportLoading
                    ? _c("span", [_vm._v("报表生成中")])
                    : _vm._e(),
                  !_vm.exportLoading ? _c("span") : _vm._e(),
                ]
              ),
              _c("el-col", { attrs: { span: 12 } }, [
                _vm.exportLoading
                  ? _c("div", { staticClass: "spinner" }, [
                      _c("div", { staticClass: "bounce1" }),
                      _c("div", { staticClass: "bounce2" }),
                      _c("div", { staticClass: "bounce3" }),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          !_vm.exportLoading
            ? _c(
                "span",
                {
                  staticStyle: {
                    "text-align": "center",
                    display: "inline-block",
                    width: "100%",
                  },
                  attrs: { download: "proposed_file_name" },
                  on: {
                    click: function ($event) {
                      _vm.exportDialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(" 报表生成成功，点击 "),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        "text-decoration": "underline",
                        color: "#2877FF",
                      },
                      attrs: { href: _vm.url, download: "" },
                    },
                    [_vm._v("下载")]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: _vm.pointQuestionTitle,
            center: "",
            visible: _vm.pointQuestionDialog,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pointQuestionDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.questionLoading,
                  expression: "questionLoading",
                },
              ],
              staticClass: "point-question-container",
            },
            [
              _vm.pointQuestionData.length > 0
                ? _vm._l(_vm.pointQuestionData, function (ques, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "point-question-item" },
                      [
                        _c("div", { staticClass: "header" }, [
                          _c("div", { staticClass: "seq" }, [
                            _vm._v(_vm._s(i + 1)),
                          ]),
                          _c("div", { staticClass: "source" }, [
                            _c("span", [_vm._v("题目来源：")]),
                            _c("span", { staticStyle: { color: "#999" } }, [
                              _vm._v(_vm._s(ques.examName)),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "body" }, [
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              ques.questionInfo.content
                                ? _c("div", {
                                    staticClass: "ques-body",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        ques.questionInfo.content
                                      ),
                                    },
                                  })
                                : _c(
                                    "div",
                                    { staticStyle: { color: "#999" } },
                                    [_vm._v("该题内容为空")]
                                  ),
                              _vm._l(
                                ques.questionInfo.options || [],
                                function (opt, j) {
                                  return _c(
                                    "div",
                                    { key: j, staticClass: "option" },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.optionList[j])),
                                      ]),
                                      _c("div", {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(opt.content),
                                        },
                                      }),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "detail" }, [
                            _c("div", { staticClass: "detail-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("【班级作答情况】"),
                              ]),
                              _c("span", [
                                _vm._v(
                                  "班级共" +
                                    _vm._s(ques.studentNum) +
                                    "人回答该题，平均得分率为" +
                                    _vm._s(
                                      parseFloat(ques.classRate * 100).toFixed(
                                        2
                                      )
                                    ) +
                                    "%"
                                ),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "detail-item" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("【知识点】"),
                                ]),
                                _vm._l(ques.items, function (p, k) {
                                  return _c(
                                    "span",
                                    { key: k, staticClass: "point-item" },
                                    [_vm._v(_vm._s(p.name))]
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]),
                      ]
                    )
                  })
                : _c("div", { staticClass: "not-data" }, [
                    _c("img", {
                      attrs: {
                        src: require("images/nodata.png"),
                        alt: "",
                        width: "100",
                      },
                    }),
                    _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                      _vm._v("暂无数据"),
                    ]),
                  ]),
            ],
            2
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.pointQuestionDialog = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("images/grade_1.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("images/grade_7.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("images/grade_5.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("images/grade_4.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("images/grade_3.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("img", { attrs: { src: require("images/grade_2.png"), alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { attrs: { id: "bestPieChart" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { attrs: { id: "worstPieChart" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }